import { render } from "./BenefitsAndInvestment.vue?vue&type=template&id=3c8f4f94&scoped=true"
import script from "./BenefitsAndInvestment.vue?vue&type=script&lang=js"
export * from "./BenefitsAndInvestment.vue?vue&type=script&lang=js"

import "./BenefitsAndInvestment.vue?vue&type=style&index=0&id=3c8f4f94&lang=scss&scoped=true"

import exportComponent from "/data/projects/dev_private_futurelab/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c8f4f94"]])

export default __exports__